import { AlternativeEditorDialogViewModel } from '@Alternatives/Alternatives/Components/AlternativeEditorDialog';
import AlternativeEditorDialog from '@Alternatives/Alternatives/Components/AlternativeEditorDialog.vue';
import { AlternativeRelationshipsDialogViewModel } from '@Alternatives/Alternatives/Components/AlternativeRelationshipsDialog';
import AlternativeRelationshipsDialog from '@Alternatives/Alternatives/Components/AlternativeRelationshipsDialog.vue';
import AttributeDataView from '@Alternatives/Alternatives/Components/AttributeDataView.vue';
import { EmailSenderFormSubmitEventPayload, EmailSenderViewModel } from '@Alternatives/Alternatives/Components/EmailSender';
import EmailSender from '@Alternatives/Alternatives/Components/EmailSender.vue';
import { LogsBrowserViewModel } from '@Alternatives/Alternatives/Components/LogsBrowser';
import LogsBrowser from '@Alternatives/Alternatives/Components/LogsBrowser.vue';
import { NoteLoggerViewModel } from '@Alternatives/Alternatives/Components/NoteLogger';
import NoteLogger from '@Alternatives/Alternatives/Components/NoteLogger.vue';
import { AddAttachedDocumentCommandV1, CreateNoteCommandV1, DeleteAttachedDocumentCommandV1, LinkDependentAlternativeCommandV1, LinkFoundationAlternativeCommandV1, SendEmailCommandV1, UnlinkDependentAlternativeCommandV1, UnlinkFoundationAlternativeCommandV1, UpdateAlternativeCommandV1 } from '@Alternatives/Alternatives/Domain/commands-core';
import AlternativesCommands from '@Alternatives/Alternatives/Domain/commands-vue-component';
import AlternativesQueries from '@Alternatives/Alternatives/Domain/queries-vue-component';
import { AlternativeAttachmentReadModel, AlternativeAttachmentsReadModel, AlternativeDashboardReadModel, AlternativeLogEntryReadModel, AlternativeLogsReadModel, AlternativeReadModel, AlternativesReadModel, AttributeDataReadModel, EmailContactReadModel } from '@Alternatives/Alternatives/Domain/readmodels';
import { ICommandBase } from '@Alternatives/cqrs';
import FileUploader from "@Blobs/Components/FileUploader.vue";
import DataSharingQueries from '@DataSharing/Shares/queries-vue-component';
import { Refresh } from '@browser/Browser';
import { strCompareLowerCase, tchMarked } from '@common/Common';
import { MonthPickerDialogViewModel } from '@common/Components/MonthPickerDialog';
import MonthPickerDialog from '@common/Components/MonthPickerDialog.vue';
import PortfolioOrDecisionNavigation from "@common/Components/PortfolioOrDecisionNavigation.vue";
import { guid } from '@common/Guid';
import Navigation from '@common/Navigation.vue';
import { MonthYear, MonthYearHelpers } from '@common/types';
import { ICommandStatus } from '@cqrs/cqrs';
import moment from "moment";
import { Component, mixins } from 'vue-facing-decorator';

@Component({
    components: {
        PortfolioOrDecisionNavigation, Navigation, FileUploader, EmailSender, NoteLogger, LogsBrowser, AttributeDataView, AlternativeRelationshipsDialog, MonthPickerDialog, AlternativeEditorDialog
    }
})
export default class AlternativeDashboardPage extends mixins(AlternativesCommands, AlternativesQueries, DataSharingQueries)
{
    get workspaceId(): number { return Number(this.$route?.params?.workspaceId ?? 0); }
    get projectId(): number { return Number(this.$route?.params?.projectId ?? 0); }
    get alternativeId(): string { return this.$route?.params?.alternativeId; }

    get alternativesListId(): number { return this.rm!.AlternativesListId; }
    get isWorkspaceMember(): boolean  { return this.rm?.IsWorkspaceMember ?? false }
    get isProjectOwner(): boolean  { return this.rm?.IsProjectOwner ?? false }

    get startDateLabel(): string | null { return MonthYearHelpers.toMonthYearLongString(this.startDate); }
    get commitmentDateLabel(): string | null { return MonthYearHelpers.toMonthYearLongString(this.commitmentDate); }


    get attributesBySection(): Record<string, AttributeDataReadModel[]>
    {
        const dictionary: Record<string, AttributeDataReadModel[]> = {};

        this.attributesView.forEach(item =>
        {
            if (!dictionary[item.Section])
            {
                dictionary[item.Section] = [];
            }

            dictionary[item.Section].push(item);
        });

        return dictionary;
    }

    get attributesView(): AttributeDataReadModel[]
    {
        let view = new Array(...this.rm.Attributes);

        if (this.searchPhrase)
        {
            const phrase = this.searchPhrase.toLowerCase();

            const view1 = view.filter(a => a.Title.toLowerCase().indexOf(phrase) > -1);
            const view2 = view.filter(a => a.Section && a.Section.toLowerCase().indexOf(phrase) > -1);
            const view3 = view.filter(a => a.ValuesAsString && a.ValuesAsString.toLowerCase().indexOf(phrase) > -1);

            const mergedMap = new Map<number, AttributeDataReadModel>();

            [...view1, ...view2, ...view3].forEach(item =>
            {
                mergedMap.set(item.AttributeId, item);
            });

            view = Array.from(mergedMap.values());
        }

        return view;
    }

    get alternativeName() { return this.rm?.Name; }
    get userId() { return this.rm?.UserId; }
    get userEmail() { return this.rm?.UserEmail; }
    get forms() { return this.rm?.Forms ?? []; }
    get emailContacts() { return this.rm?.EmailContacts ?? []; }

    get resourceShares() { return this.resourceSharesRm?.Shares ?? []; }
    get resourceActiveShares() { return this.resourceShares.filter((s: any) => !s.Expired && !s.IsPaused); }

    rm: AlternativeDashboardReadModel = null;
    lastLogRm: AlternativeLogEntryReadModel = null;
    attachmentsRm: AlternativeAttachmentsReadModel = null;
    resourceSharesRm: any = null
    startDate: MonthYear | null = null;
    commitmentDate: MonthYear | null = null;

    startDateMonthPicker: MonthPickerDialogViewModel = new MonthPickerDialogViewModel();
    commitmentDateMonthPicker: MonthPickerDialogViewModel =  new MonthPickerDialogViewModel();
    alternativeEditorDialog: AlternativeEditorDialogViewModel = new AlternativeEditorDialogViewModel();
    noteLogger: NoteLoggerViewModel = new NoteLoggerViewModel();
    logsBrowser: LogsBrowserViewModel = new LogsBrowserViewModel();
    emailSender: EmailSenderViewModel = new EmailSenderViewModel();
    alternativeRelationshipsDialog: AlternativeRelationshipsDialogViewModel | null = null;


    file: File = null;
    searchPhrase: string | null = null;
    allAlternatives: AlternativeReadModel[] | null; 

    get attachmentsView(): AlternativeAttachmentReadModel[]
    {
        if (!this.attachmentsRm) return [];

        const view = new Array(...this.attachmentsRm.Attachments);
        return view.sort((a, b) => strCompareLowerCase(a.Title, b.Title));
    }

    showAlternativeEditor(formId: number | null)
    {
        this.alternativeEditorDialog.showEditor(this.workspaceId, this.projectId, this.alternativesListId, this.rm.Id, formId, this.rm.AlternativeLabel);
    }

    showDependenciesManager()
    {
        this.alternativeRelationshipsDialog.show(this.rm.Id, this.rm.Name, this.rm.StatusId, this.rm.StatusName, this.rm.Dependents, this.rm.Foundations,
            this.rm.AlternativeLabel, this.rm.AlternativesLabel);

    }

    showLogsBrowser()
    {
        this.logsBrowser.show();
        this.runAlternativeLogsQueryV1(this.workspaceId, this.projectId, this.alternativeId);
    }

    showEmailSender(emailTo: EmailContactReadModel | null)
    {
        this.emailSender.show(this.alternativeId, this.alternativeName, emailTo?.Email ?? null, this.userEmail, this.rm!.EmailSnippets);
    }

    showStartDateMonthPicker()
    {
        this.startDateMonthPicker.show(this.startDate, 'Edit start date', false);
    }

    showCommitmentDateMonthPicker()
    {
        this.commitmentDateMonthPicker.show(this.commitmentDate, 'Edit commitment date', false);
    }

    marked(str: string): string
    {
        return tchMarked(str);
    }

    getHumanizedTimeSince(dateStr: string)
    {
        const date = moment(dateStr);
        return moment.duration(moment().diff(date)).humanize().replace(' ', '&nbsp;');
    }

    handleShowNoteLogger()
    {
        this.noteLogger.show();
    }

    handleEmailSenderFormSubmit(e: EmailSenderFormSubmitEventPayload)
    {
        this.invokeSendEmailCommandV1(this.userId, this.workspaceId, this.alternativesListId, this.alternativeId, e.subject, e.replyToEmail, e.to, e.bodyHtml);
    }


    loadAlternativesForDependencyDialog()
    {
        this.runDependencyDialogAlternativesQueryV1(this.workspaceId, this.projectId, this.alternativeId);
    }

    handleAddAttachedDocumentCommand(blobId: string)
    {
        this.invokeAddAttachedDocumentCommandV1(this.userId, this.workspaceId, this.alternativesListId, this.alternativeId, guid(), blobId);
    }

    handleDeleteAttachedDocumentCommand(attachment: AlternativeAttachmentReadModel)
    {
        this.invokeDeleteAttachedDocumentCommandV1(this.userId, this.workspaceId, this.alternativesListId, this.alternativeId, attachment.Id);
    }

    handleCreateNoteCommand(note: string)
    {
        this.invokeCreateNoteCommandV1(this.workspaceId, this.projectId, this.alternativeId, guid(), note);
    }

    handleUpdateAlternativeStartDateCommand(date: MonthYear | null)
    {
        this.startDate = date;
        this.invokeUpdateAlternativeStartDateCommandV1(this.workspaceId, this.projectId, this.alternativesListId, this.alternativeId, this.startDate)
    }

    handleUpdateAlternativeCommitmentDateCommand(date: MonthYear | null)
    {
        this.commitmentDate = date;
        this.invokeUpdateAlternativeCommitmentDateCommandV1(this.workspaceId, this.projectId, this.alternativesListId, this.alternativeId, this.commitmentDate)
    }

    handleUnlinkDependentAlternativeCommand(dependentId: string)
    {
        if (confirm("Are you sure you want to remove this dependency?"))
        {
            this.invokeUnlinkDependentAlternativeCommandV1(this.userId, this.workspaceId, this.projectId, this.alternativesListId, this.alternativeId, dependentId);
        }
    }

    handleUnlinkFoundationAlternativeCommand(foundationId: string)
    {
        if (confirm("Are you sure you want to remove this dependency?"))
        {
            this.invokeUnlinkFoundationAlternativeCommandV1(this.userId, this.workspaceId, this.projectId, this.alternativesListId, this.alternativeId, foundationId);
        }
    }

    handleLinkFoundationAlternativeCommand(foundationId: string)
    {
        this.invokeLinkFoundationAlternativeCommandV1(this.userId, this.workspaceId, this.projectId, this.alternativesListId, this.alternativeId, foundationId);
    }

    handleLinkDependentAlternativeCommand(dependentId: string)
    {
        this.invokeLinkDependentAlternativeCommandV1(this.userId, this.workspaceId, this.projectId, this.alternativesListId, this.alternativeId, dependentId);
    }


    mounted()
    {
        this.alternativeRelationshipsDialog = new AlternativeRelationshipsDialogViewModel(this.workspaceId, this.projectId);

        this.runAlternativeDashboardQueryV1(this.workspaceId, this.projectId, this.alternativeId);
        this.runLastAlternativeLogEntryQueryV1(this.workspaceId, this.projectId, this.alternativeId);
        this.runAlternativeAttachmentsQueryV1(this.workspaceId, this.projectId, this.alternativeId);
    }

    onSetModel(model: any, modelName: string)
    {
        if (modelName === "AlternativeDashboardReadModel")
        {
            this.rm = model as AlternativeDashboardReadModel;

            document.title = this.rm.Name;
            this.startDate = MonthYearHelpers.copyNullable(this.rm.StartDate);
            this.commitmentDate = MonthYearHelpers.copyNullable(this.rm.CommitmentDate);

            if (this.rm.IsWorkspaceMember)
            {
                this.runResourceSharesQueryV1('AlternativesDataShareResourceProvider', this.alternativeId)
            }
        }
        else if (modelName === "AlternativeLogsReadModel")
        {
            const rm = model as AlternativeLogsReadModel;
            this.logsBrowser.setData(rm.Logs);
        }
        else if (modelName === "AlternativeLogEntryReadModel")
        {
            this.lastLogRm = model as AlternativeLogEntryReadModel;
        }
        else if (modelName === "AlternativeAttachmentsReadModel")
        {
            this.attachmentsRm = model as AlternativeAttachmentsReadModel;
        }
        else if (modelName === "AlternativeAttachmentReadModel")
        {
            const rm = model as AlternativeAttachmentReadModel;
            this.attachmentsRm.Attachments.push(rm);
            this.file = null;
        }
        else if (modelName === "ResourceSharesReadModel")
        {
            this.resourceSharesRm = model
        }
        if (modelName === "AlternativesReadModel")
        {

            const rm = model as AlternativesReadModel;
            this.allAlternatives = rm.Alternatives;
            this.alternativeRelationshipsDialog.setAlternatives(this.allAlternatives);
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (CreateNoteCommandV1.matchType(cmd))
        {
            this.runAlternativeLogEntryQueryV1(this.workspaceId, this.alternativeId, correlationId);
            this.noteLogger.close();
        }
        else if (DeleteAttachedDocumentCommandV1.matchType(cmd))
        {
            const curr = this.attachmentsRm.Attachments.find(a => a.Id === correlationId);
            this.attachmentsRm.Attachments.remove(curr);
        }
        else if (AddAttachedDocumentCommandV1.matchType(cmd))
        {
            this.runAlternativeAttachmentQueryV1(this.workspaceId, this.alternativeId, correlationId);
        }
        else if (SendEmailCommandV1.matchType(cmd))
        {
            this.emailSender.close();
        }
        else if (UpdateAlternativeCommandV1.matchType(cmd))
        {
            Refresh();
        }
        else if (UnlinkDependentAlternativeCommandV1.matchType(cmd))
        {
            this.rm.Dependents = this.rm.Dependents.filter(a => a.Id !== correlationId);
            this.alternativeRelationshipsDialog.removeDependent(correlationId);
        }
        if (LinkDependentAlternativeCommandV1.matchType(cmd))
        {
            const d = this.allAlternatives.find(a => a.Id === correlationId);
            this.alternativeRelationshipsDialog.addDependent(correlationId);
        }
        else if (LinkFoundationAlternativeCommandV1.matchType(cmd))
        {
            const f = this.allAlternatives.find(a => a.Id === correlationId);
            this.alternativeRelationshipsDialog.addFoundation(correlationId);
        }
        else if (UnlinkFoundationAlternativeCommandV1.matchType(cmd))
        {
            this.rm.Foundations = this.rm.Foundations.filter(a => a.Id !== correlationId);
            this.alternativeRelationshipsDialog.removeFoundation(correlationId);
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (SendEmailCommandV1.matchType(status.Command))
        {
            this.emailSender.displayValidationErrors(status.ValidationErrors);
        }
    }
}